import { useLocation } from "react-router";

export const useQueryParam = (key: string): string => {
    const { search } = useLocation();
    const query = new URLSearchParams(search);

    return query.get(key) || "";
};
